import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Breadcrumbs from './components/Breadcrumbs';
import Footer from './components/Footer';
import Home from './components/Home';
import Category from './components/Category';
import Product from './components/Product';
import Search from './components/Search';
import MyAccount from './components/MyAccount';
import Checkout from './components/Checkout';
import PayPalReturn from './components/checkout/PayPalReturn';
import PayPalCancel from './components/checkout/PayPalCancel';
import CheckoutSuccess from './components/checkout/CheckoutSuccess';
import StaticPage from './components/StaticPage';
import AuthNetCommunicator from './components/AuthNetCommunicator';
import MiniCart from './components/MiniCart';
import LoginModal from './components/LoginModal';
import RegisterModal from './components/RegisterModal';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { BreadcrumbProvider } from './context/BreadcrumbContext';
import { WishlistProvider } from './context/WishlistContext';
import './App.css';

const App = () => {
  return (
    <AuthProvider>
      <CartProvider>
        <WishlistProvider>
          <BreadcrumbProvider>
            <div className="App">
              <Header />
              <Breadcrumbs />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/search" element={<Search />} />
                  <Route path="/my-account" element={<MyAccount />} />
                  <Route path="/about" element={<StaticPage />} />
                  <Route path="/contact" element={<StaticPage />} />
                  <Route path="/privacy-policy" element={<StaticPage />} />
                  <Route path="/terms-of-service" element={<StaticPage />} />
                  <Route path="/shipping-delivery" element={<StaticPage />} />
                  <Route path="/returns-refunds" element={<StaticPage />} />
                  <Route path="/*" element={<Category />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/checkout/success" element={<CheckoutSuccess />} />
                  <Route path="/paypal/return" element={<PayPalReturn />} />
                  <Route path="/paypal/cancel" element={<PayPalCancel />} />
                  <Route path="/checkout/paypal/return" element={<PayPalReturn />} />
                  <Route path="/checkout/paypal/cancel" element={<PayPalCancel />} />
                  <Route path="/authnetcim/hosted/communicator" element={<AuthNetCommunicator />} />
                  <Route path="/authnetcim/hosted/communicator/*" element={<AuthNetCommunicator />} />
                </Routes>
              </main>
              <Footer />
              <MiniCart />
              <LoginModal />
              <RegisterModal />
            </div>
          </BreadcrumbProvider>
        </WishlistProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;